<template>
	<div>
		<van-cell is-link="">
			<div class="list-box" @click="showCalendar = true">
				<p>消杀日期</p>
				<p v-text="dateVlue" v-show="dateVlue != ''"></p>
				<p v-show="dateVlue == ''">请选择日期</p>
			</div>
		</van-cell>

		<van-cell is-link="">
			<div class="list-box" @click="showPicker = true">
				<p>具体消杀时间</p>
				<p v-text="timeValue" v-show="timeValue != ''"></p>
				<p v-show="timeValue == ''">请选择时间</p>
			</div>
		</van-cell>

		<van-cell>
			<div class="list-box">
				<p>消杀范围</p>
				<div>
					<van-field v-model="rangeValue" placeholder="请输入" input-align="right" />
				</div>
			</div>
		</van-cell>

		<van-cell>
			<div class="list-box">
				<p>消杀用量</p>
				<div>
					<van-field v-model="useValue" placeholder="请输入" input-align="right" />
				</div>
			</div>
		</van-cell>

		<van-cell>
			<div class="list-box">
				<p>消杀人员</p>
				<div>
					<van-field v-model="peopleValue" placeholder="请输入" input-align="right" />
				</div>
			</div>
		</van-cell>

		<van-calendar v-model="showCalendar" :default-date='today' :min-date="minDate" :max-date="maxDate" @confirm="DateConfirm" />

		<van-popup v-model="showPicker" position="bottom">
			<van-datetime-picker type="time" @confirm="timeConfirm" @cancel="showPicker = false" />
		</van-popup>

		<van-button block="" type="info" native-type="submit" @click='submitData'>提交</van-button>
		<bottom-tab></bottom-tab>
	</div>

</template>

<script>
	import Vue from 'vue';
	import {
		Form
	} from 'vant';
	import {
		Calendar
	} from 'vant';
	import {
		DatetimePicker
	} from 'vant';
	import {
		Cell
	} from 'vant'
	import {
		Field
	} from 'vant';

	Vue.use(Field);
	Vue.use(DatetimePicker);
	Vue.use(Calendar);
	Vue.use(Form);
	Vue.use(Cell);

	export default {
		data() {
			return {
				today: new Date(),
				dateVlue: '', // 日期
				showCalendar: false,
				timeValue: '', // 时间
				showPicker: false,
				rangeValue: '', // 消杀范围
				useValue: '', // 消杀用量
				peopleValue: '', //消杀人员
				minDate: new Date(2020, 0, 1),
				maxDate: new Date(2030, 0, 31)
			};
		},
		methods: {
			DateConfirm(date) {
				this.dateVlue = this.formatDate(date, 'yyyy/MM/dd')
				this.showCalendar = false;
			},
			timeConfirm(time) {
				this.timeValue = time;
				this.showPicker = false;
			},
			submitData() {
				console.log(this.dateVlue);
				console.log(this.timeValue);
				console.log(this.rangeValue);
				console.log(this.useValue);
				console.log(this.peopleValue);
			},
			formatDate(date, fmt) {
				date = date == undefined ? new Date() : date;
				date = typeof date == "number" ? new Date(date) : date;
				fmt = fmt || "yyyy-MM-dd HH:mm:ss";
				let obj = {
					y: date.getFullYear(), // 年份，注意必须用getFullYear
					M: date.getMonth() + 1, // 月份，注意是从0-11
					d: date.getDate(), // 日期
					q: Math.floor((date.getMonth() + 3) / 3), // 季度
					w: date.getDay(), // 星期，注意是0-6
					H: date.getHours(), // 24小时制
					h: date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 12小时制
					m: date.getMinutes(), // 分钟
					s: date.getSeconds(), // 秒
					S: date.getMilliseconds() // 毫秒
				};
				let week = ["天", "一", "二", "三", "四", "五", "六"];
				for (let i in obj) {
					fmt = fmt.replace(new RegExp(i + "+", "g"), function(m) {
						let val = obj[i] + "";
						if (i == "w") return (m.length > 2 ? "星期" : "周") + week[val];
						for (let j = 0, len = val.length; j < m.length - len; j++)
							val = "0" + val;
						return m.length == 1 ? val : val.substring(val.length - m.length);
					});
				}
				return fmt;
			}
		},
	};
</script>

<style scoped>
	.list-box {
		display: flex;
		justify-content: space-between;
	}

	.list-box p {
		margin: 0;
		line-height: 44px;
	}

	.list-box p:nth-child(3) {
		color: #C0C4CC;
	}

	.van-cell__right-icon {
		line-height: 44px;
	}
</style>
